import "@/styles/globals.css";

import { ThemeProvider } from "@norican/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "@/App";
import { queryClient } from "@/lib/api";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme="light" density="comfortable">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
      {/* Dev only; its floating button sits top-right so it never covers the card column on a phone */}
      {import.meta.env.DEV && (
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" />
      )}
    </QueryClientProvider>
  </StrictMode>,
);
